import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\"></path><g fill=\"#FFF\" fill-rule=\"nonzero\"><path d=\"M1.6 12.002c0 .388.314.703.703.703h13.39l-2.612 2.608a.703.703 0 0 0 .495 1.198.7.7 0 0 0 .494-.205l3.806-3.805a.703.703 0 0 0 0-.993L14.07 7.702a.703.703 0 0 0-.993.993l2.608 2.608H2.303a.7.7 0 0 0-.703.7\"></path><path d=\"M17.802 22A4.2 4.2 0 0 0 22 17.798V6.202A4.205 4.205 0 0 0 17.802 2H6.206a4.2 4.2 0 0 0-4.198 4.202v2.383a.702.702 0 0 0 1.402 0V6.202c0-1.541 1.255-2.8 2.796-2.8h11.596a2.8 2.8 0 0 1 2.796 2.8v11.596c0 1.541-1.255 2.8-2.796 2.8H6.206a2.8 2.8 0 0 1-2.796-2.8v-2.354a.703.703 0 0 0-.703-.703.7.7 0 0 0-.699.703v2.354A4.205 4.205 0 0 0 6.206 22z\"></path></g></g>", 1)
  ]))]))
}
export default { render: render }